// extracted by mini-css-extract-plugin
module.exports = {"portal-group-nav-wrapper":"PortalGroupNav_portal-group-nav-wrapper__1CtZh"};